export default __webpack_public_path__ + "static/media/egalitarian-3.f4a85048.jpg";